import React, { useState, useEffect, useRef } from "react";
import './PagesCss/Products.css';
import { useNavigate } from "react-router-dom";

/* ═══════════════════════════════════════════════════
   PRODUCT DATA
═══════════════════════════════════════════════════ */
const PRODUCTS = [
  {
    id: "01",
    name: "Temp-MailHub",
    domain: "temp-mailhub.com",
    url: "https://temp-mailhub.com",
    status: "progress",
    statusLabel: "In Progress",
    category: "Privacy & Email",
    tagline: "Advanced automated email workflows for privacy-first users.",
    description:
      "Temp-MailHub is a privacy-first email platform by D-Tech Studios, offering disposable inboxes, email aliases, and automated workflows giving developers and power users full control and efficiency.",
    features: [
        "Automated disposable inboxes",
    "Custom email aliases",
    "Email workflow automation",
    "Seamless integration options",
    "Secure, privacy-first design",
    "Developer-friendly API",
    "Custom domain support",
    "Advanced forwarding and routing",
    ],
    accent: "#19453f",
    icon: '/image/Temp-MailHub.svg',
  },
  {
    id: "02",
    name: "Talkified",
    domain: "talkified.com",
    url: "https://talkified.com",
    status: "prototype",
    statusLabel: "Prototype",
    category: "Voice & Audio AI",
    tagline: "Studio-grade voice AI for creators, storytellers, and builders.",
    description:
    "Talkified is a creator-focused voice AI platform by D-Tech Studios, combining text-to-speech, speech-to-text, and voice cloning into a single studio. It enables expressive, high-fidelity audio production for creators without a recording booth.",
    features: [
      "Text-to-Speech (TTS)",
    "Speech-to-Text (STT)",
    "Voice Cloning",
    "Audio Production Studio",
    "Creator API",
    "Multi-language Support",
    "STT-Based Tools",
    ],
    accent: "#1e1b4b",
    icon: '/image/Talkified.svg',
  },
  {
    id: "03",
    name: "AfterTaxPay",
    domain: "aftertaxpay.net",
    url: "https://aftertaxpay.net",
    status: "live",
    statusLabel: "Live",
    category: "Finance & Tax",
    tagline: "Accurate take-home pay, instantly.",
    description:
    "AfterTaxPay is a D-Tech Studios finance tool that calculates net income with precision. Enter your gross pay, select your region, and see instant deductions, effective tax rate, and take-home pay clear, fast, and reliable.",
    features: [
      "Instant net income calculation",
    "Detailed tax breakdown",
    "Freelancer & employee tools",
    "Multi-region support",
    "Effective tax rate insights",
    ],
    accent: "#0F172A",
    icon: '/image/AfterTaxPay.svg',
  },
  {
    id: "04",
    name: "CreditsIQ",
    domain: "creditsiq.com",
    url: "https://creditsiq.com",
    status: "prototype",
    statusLabel: "Prototype",
    category: "Personal Finance",
    tagline: "Know, improve, and protect your credit score.",
    description:
      "CreditsIQ is a credit score education and tooling platform that demystifies credit for everyday users. Explore score simulators, learn what actually moves your credit, understand utilisation ratios, and get actionable steps to build a stronger financial profile.",
    features: [
      "Credit score simulator",
    "Clear credit explanations",
    "Utilization calculator",
    "Step-by-step building guides",
    "Dispute tracking",
    ],
    accent: "#A03B00",
    icon: '/image/CreditsIQ.svg',
  },
  {
    id: "05",
    name: "CryptoMux",
    domain: "cryptomux.com",
    url: "https://cryptomux.com",
    status: "idea",
    statusLabel: "Idea Phase",
    category: "Crypto & Web3",
    tagline: "Comprehensive crypto tools for traders and researchers.",
    description:
    "CryptoMux is a D-Tech Studios crypto platform providing calculators for profit/loss, DCA, and fees, with future plans for portfolio analytics, on-chain tools, and a research hub all designed for serious crypto participants.",
    features: [
      "Profit/Loss Calculator",
    "DCA Calculator",
    "Fee Estimator",
    "Portfolio Analytics (coming soon)",
    "On-Chain Tools (coming soon)",
    "Token Comparisons (coming soon)",
    ],
    accent: "#0F3054",
    icon: '/image/CryptoMux.svg',
  },
  {
    id: "06",
    name: "Font-Max",
    domain: "font-max.com",
    url: "https://font-max.com",
    status: "live",
    statusLabel: "Live",
    category: "Design & Typography",
    tagline: "All-in-one typography toolkit for designers and developers.",
    description:
    "Font-Max is a D-Tech Studios typography platform, letting designers and developers preview fonts, test pairings, convert files, generate CSS, and explore type scales all directly in the browser.",
    features: [
      "Font preview & testing",
    "Pairing tester",
    "File conversion",
    "CSS snippet generator",
    "Type scale explorer",
    "Google Fonts browser",
    ],
    accent: "#F7243C",
    icon: '/image/Font-Max.svg',
  },
  {
    id: "07",
    name: "QuickPDFs",
    domain: "quickpdfs.net",
    url: "https://quickpdfs.net",
    status: "live",
    statusLabel: "Live",
    category: "Productivity & Documents",
    tagline: "Effortless PDF tools, all in one place.",
    description:
    "QuickPDFs is a D-Tech Studios PDF platform that lets users merge, split, compress, convert, rotate, and annotate PDFs directly in the browser fast, reliable, and hassle-free.",
    features: [
      "Merge & split PDFs",
    "Compress documents",
    "PDF to Word/Excel conversion",
    "Image to PDF",
    "Rotate & reorder pages",
    "Annotate & sign PDFs",
    ],
    accent: "#0F172A",
    icon: '/image/QuickPDFs.svg',
  },
  {
    id: "08",
    name: "AIPicks",
    domain: "aipicks.org",
    url: "https://aipicks.org",
    status: "live",
    statusLabel: "Live",
    category: "AI Directory",
    tagline: "Discover the best AI tools in one place.",
    description:
    "AIPicks is a D-Tech Studios AI directory, curated to help developers, founders, and enthusiasts discover high-quality AI products across categories. Every listing is selected for relevance, usefulness, and reliability.",
    features: [
      "Curated AI tool submissions",
    "Category-based browsing",
    "Ratings & reviews",
    "Trending AI tools",
    "Newsletter updates",
    "Free tool listings",
    ],
    accent: "#06b6d4",
    icon: '/image/AIPicks.png',
  },
  {
    id: "09",
    name: "NoobToBull",
    domain: "noobtobull.com",
    url: "https://noobtobull.com",
    status: "idea",
    statusLabel: "Idea Phase",
    category: "Investing & Stocks",
    tagline: "Stock market tools for beginners and aspiring investors.",
    description:
    "NoobToBull is a D-Tech Studios platform designed to simplify investing for beginners. It provides calculators for position sizing, compound growth, and dividends, with plans for full education, portfolio tracking, and analytics tools.",
    features: [
      "Position size calculator",
    "Compound growth tool",
    "Dividend calculator",
    "Investing guides (coming soon)",
    "Portfolio tracker (coming soon)",
    "Watchlist builder (coming soon)",
    ],
    accent: "#19692C",
    icon: '/image/NoobToBull.svg',
  },
  {
    id: "10",
    name: "D-Tech Tools",
    domain: "tools.d-techstudios.com",
    url: "https://tools.d-techstudios.com",
    status: "live",
    statusLabel: "Live",
    category: "Math & Utilities",
    tagline: "Practical math and utility tools, built in-house.",
    description:
    "D-Tech Tools is D-Tech Studios’ in-house toolkit, offering calculators, converters, and utility tools designed for precision, speed, and ease of use. Every tool is maintained internally, reflecting our commitment to high-quality, practical software.",
    features: [
      "Math calculators",
    "Unit converters",
    "Percentage & ratio tools",
    "Equation solver",
    "Always free",
    "More tools coming",
    ],
    accent: "#8665e4",
    icon: '/image/Math.svg',
  },
];

const FILTERS = [
  { key: "all",      label: "All Products",  count: PRODUCTS.length },
  { key: "live",     label: "Live",           count: PRODUCTS.filter(p => p.status === "live").length },
  { key: "progress", label: "In Progress",    count: PRODUCTS.filter(p => p.status === "progress").length },
  { key: "prototype",label: "Prototype",      count: PRODUCTS.filter(p => p.status === "prototype").length },
  { key: "idea",     label: "Idea Phase",     count: PRODUCTS.filter(p => p.status === "idea").length },
];

/* ── intersection reveal hook ── */
function useReveal() {
  const [seen, setSeen] = useState(new Set());
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) setSeen((p) => new Set([...p, e.target.dataset.key]));
      }),
      { threshold: 0.08 }
    );
    document.querySelectorAll("[data-key]").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
  return (k) => seen.has(k);
}

/* ── Status badge config ── */
const STATUS_META = {
  live:      { label: "Live",        cls: "pb-live" },
  progress:  { label: "In Progress", cls: "pb-progress" },
  prototype: { label: "Prototype",   cls: "pb-proto" },
  idea:      { label: "Idea Phase",  cls: "pb-idea" },
};

/* ── Logo placeholder component ── */
function LogoBox({ product }) {
  const Icon = product.icon;
  return (
    <div className="pc-logo" style={{ "--accent": product.accent }}>
      {typeof Icon === "string" ? (
        <img src={Icon} alt={product.name} className="pc-logo-img" />
      ) : (
        <Icon className="pc-logo-img" />
      )}
    </div>
  );
}

/* ── Single product card FIXED expand ── */
function ProductCard({ product, index }) {
  const [expanded, setExpanded] = useState(false);
  const descRef = useRef(null);
  const [descHeight, setDescHeight] = useState(0);
  const meta = STATUS_META[product.status];

  useEffect(() => {
    if (descRef.current) {
      setDescHeight(descRef.current.scrollHeight);
    }
  }, []);

  return (
    <article
      className={`pc-card pc-card--${product.status} ${expanded ? "pc-card--open" : ""}`}
      data-key={`card-${product.id}`}
      style={{ animationDelay: `${(index % 3) * 0.08}s` }}
    >
      {/* card header */}
      <div className="pc-card-head">
        <div className="pc-head-left">
          <LogoBox product={product} />
          <div className="pc-head-info">
            <div className="pc-head-top">
              <span className="pc-num">{product.id}</span>
              <span className={`pc-badge ${meta.cls}`}>{meta.label}</span>
            </div>
            <h3 className="pc-name">{product.name}</h3>
            <a
              href={product.url}
              target="_blank"
              rel="noopener noreferrer"
              className="pc-domain"
              onClick={e => e.stopPropagation()}
            >
              {product.domain} ↗
            </a>
          </div>
        </div>
        <button
          className="pc-expand"
          onClick={() => setExpanded(e => !e)}
          aria-label={expanded ? "Collapse" : "Expand"}
          aria-expanded={expanded}
        >
          <svg className="pc-expand-svg" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="10" y1="4" x2="10" y2="16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"
              className={`pc-plus-v ${expanded ? "pc-plus-v--hidden" : ""}`}
            />
            <line x1="4" y1="10" x2="16" y2="10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>
      </div>

      {/* category + tagline always visible */}
      <div className="pc-card-mid">
        <span className="pc-category">{product.category}</span>
        <p className="pc-tagline">{product.tagline}</p>
      </div>

      {/* feature pills always visible */}
      <div className="pc-features">
        {product.features.map((f, i) => (
          <span
            className={`pc-feat ${f.toLowerCase().includes("soon") ? "pc-feat--soon" : ""}`}
            key={i}
          >
            {f}
          </span>
        ))}
      </div>

      {/* expandable description */}
      <div
        className="pc-desc-wrap"
        style={{
          maxHeight: expanded ? `${descHeight + 60}px` : "0px",
          overflow: "hidden",
          transition: "max-height 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
        }}
      >
        <div ref={descRef} className="pc-desc-inner">
          <p className="pc-desc">{product.description}</p>
          <a
            href={product.url}
            target="_blank"
            rel="noopener noreferrer"
            className="pc-visit-btn"
            style={{ "--accent": product.accent }}
          >
            Visit {product.name}
            <span className="pc-visit-arr">→</span>
          </a>
        </div>
      </div>

      {/* accent bar on hover */}
      <div className="pc-accent-bar" style={{ "--accent": product.accent }} />
    </article>
  );
}

/* ── SVG inline icons for innovation section ── */
const IconBolt = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="pr-innov-svg">
    <path d="M13 2L4.5 13.5H11L10 22L19.5 10.5H13L13 2Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round"/>
  </svg>
);

const IconGlobe = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="pr-innov-svg">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6"/>
    <path d="M12 3C12 3 8 7 8 12C8 17 12 21 12 21" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <path d="M12 3C12 3 16 7 16 12C16 17 12 21 12 21" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <path d="M3 12H21" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <path d="M4.5 7.5H19.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <path d="M4.5 16.5H19.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
  </svg>
);

const IconCode = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="pr-innov-svg">
    <polyline points="16 18 22 12 16 6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="8 6 2 12 8 18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconRocket = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="pr-innov-svg">
    <path d="M12 2C12 2 7 6 7 13H17C17 6 12 2 12 2Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/>
    <path d="M7 13L5 17H19L17 13" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/>
    <circle cx="12" cy="10" r="2" stroke="currentColor" strokeWidth="1.6"/>
    <path d="M9 17V19C9 20.1 9.9 21 11 21H13C14.1 21 15 20.1 15 19V17" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/>
  </svg>
);

const IconEye = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="pr-innov-svg">
    <path d="M2 12C2 12 5 5 12 5C19 5 22 12 22 12C22 12 19 19 12 19C5 19 2 12 2 12Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/>
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.6"/>
  </svg>
);

const IconTarget = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="pr-innov-svg">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6"/>
    <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="1.6"/>
    <circle cx="12" cy="12" r="1.5" fill="currentColor"/>
  </svg>
);

/* ─────────────────────────────────────────────────
   CATEGORY SVG ICONS  (replaces emoji)
───────────────────────────────────────────────── */
const CatIconEmail = () => (
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" className="pr-cat-svg">
    <rect x="3" y="6" width="22" height="16" rx="3" stroke="currentColor" strokeWidth="1.6"/>
    <path d="M3 9l11 7 11-7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 14l-4 5M20 14l4 5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" opacity="0.4"/>
  </svg>
);

const CatIconVoice = () => (
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" className="pr-cat-svg">
    <rect x="10" y="3" width="8" height="14" rx="4" stroke="currentColor" strokeWidth="1.6"/>
    <path d="M5 14c0 4.97 4.03 9 9 9s9-4.03 9-9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <line x1="14" y1="23" x2="14" y2="26" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <line x1="10" y1="26" x2="18" y2="26" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <line x1="14" y1="8" x2="14" y2="11" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.5"/>
  </svg>
);

const CatIconFinance = () => (
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" className="pr-cat-svg">
    <circle cx="14" cy="14" r="10" stroke="currentColor" strokeWidth="1.6"/>
    <path d="M14 7v2M14 19v2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <path d="M10 11.5c0-1.38 1.79-2.5 4-2.5s4 1.12 4 2.5c0 1.38-1.79 2-4 2s-4 .62-4 2c0 1.38 1.79 2.5 4 2.5s4-1.12 4-2.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
  </svg>
);

const CatIconCrypto = () => (
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" className="pr-cat-svg">
    <path d="M10 8h5.5C17.43 8 19 9.57 19 11.5S17.43 15 15.5 15H10V8z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/>
    <path d="M10 15h6c2.21 0 4 1.79 4 4s-1.79 4-4 4H10V15z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/>
    <line x1="8" y1="8" x2="8" y2="23" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <line x1="12" y1="5" x2="12" y2="8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <line x1="16" y1="5" x2="16" y2="8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <line x1="12" y1="23" x2="12" y2="26" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <line x1="16" y1="23" x2="16" y2="26" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
  </svg>
);

const CatIconDesign = () => (
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" className="pr-cat-svg">
    <path d="M6 22L10 10l4 8 3-5 5 9H6z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round"/>
    <circle cx="20" cy="8" r="3" stroke="currentColor" strokeWidth="1.6"/>
    <path d="M14 6H7a2 2 0 00-2 2v12" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" opacity="0.4"/>
  </svg>
);

const CatIconAI = () => (
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" className="pr-cat-svg">
    <rect x="5" y="8" width="18" height="13" rx="3" stroke="currentColor" strokeWidth="1.6"/>
    <path d="M9 8V6M14 8V5M19 8V6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <circle cx="10" cy="14.5" r="1.5" fill="currentColor" opacity="0.7"/>
    <circle cx="14" cy="14.5" r="1.5" fill="currentColor" opacity="0.7"/>
    <circle cx="18" cy="14.5" r="1.5" fill="currentColor" opacity="0.7"/>
    <path d="M3 13v3M25 13v3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
  </svg>
);

/* ─────────────────────────────────────────────────
   MANIFESTO RIGHT-SIDE PANEL
───────────────────────────────────────────────── */
function ManifestoRight() {
  const values = [
    { label: "Privacy-first", sub: "Zero tracking. Zero noise." },
    { label: "Built in-house", sub: "No outsourcing. Full ownership." },
    { label: "Always free tiers", sub: "Access without barriers." },
    { label: "Automation-native", sub: "Repetition is a bug we fix." },
    { label: "Long-term maintained", sub: "We build it. We maintain it." },
  ];

  return (
    <div className="pr-manifesto-right">
      {/* decorative orbit graphic */}
      <div className="pr-mright-orbit" aria-hidden="true">
        <svg viewBox="0 0 260 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="pr-mright-svg">
          {/* outer ring */}
          <circle cx="130" cy="130" r="118" stroke="rgba(255,255,255,0.06)" strokeWidth="1"/>
          {/* mid ring */}
          <circle cx="130" cy="130" r="82" stroke="rgba(255,255,255,0.08)" strokeWidth="1"/>
          {/* inner ring */}
          <circle cx="130" cy="130" r="46" stroke="rgba(255,255,255,0.12)" strokeWidth="1"/>
          {/* center dot */}
          <circle cx="130" cy="130" r="6" fill="rgba(255,255,255,0.18)"/>
          {/* orbit dots outer */}
          <circle cx="130" cy="12" r="4" fill="rgba(255,255,255,0.25)"/>
          <circle cx="220" cy="80" r="3" fill="rgba(255,255,255,0.18)"/>
          <circle cx="248" cy="130" r="5" fill="rgba(255,255,255,0.12)"/>
          <circle cx="40" cy="180" r="3.5" fill="rgba(255,255,255,0.2)"/>
          {/* orbit dots mid */}
          <circle cx="130" cy="48" r="3" fill="rgba(255,255,255,0.3)"/>
          <circle cx="195" cy="100" r="2.5" fill="rgba(255,255,255,0.22)"/>
          <circle cx="65" cy="160" r="2.5" fill="rgba(255,255,255,0.22)"/>
          {/* connecting lines */}
          <line x1="130" y1="130" x2="130" y2="12" stroke="rgba(255,255,255,0.05)" strokeWidth="1" strokeDasharray="4 6"/>
          <line x1="130" y1="130" x2="220" y2="80" stroke="rgba(255,255,255,0.05)" strokeWidth="1" strokeDasharray="4 6"/>
          <line x1="130" y1="130" x2="40" y2="180" stroke="rgba(255,255,255,0.05)" strokeWidth="1" strokeDasharray="4 6"/>
          {/* label text inside center */}
          <text x="130" y="126" textAnchor="middle" fill="rgba(255,255,255,0.35)" fontSize="8" fontFamily="monospace" letterSpacing="2">D-TECH</text>
          <text x="130" y="138" textAnchor="middle" fill="rgba(255,255,255,0.18)" fontSize="7" fontFamily="monospace" letterSpacing="1">STUDIOS</text>
        </svg>
      </div>

      {/* values list */}
      <ul className="pr-mright-values">
        {values.map((v, i) => (
          <li key={i} className="pr-mright-val" style={{ animationDelay: `${0.1 + i * 0.08}s` }}>
            <span className="pr-mright-dot" />
            <span className="pr-mright-val-inner">
              <span className="pr-mright-label">{v.label}</span>
              <span className="pr-mright-sub">{v.sub}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

/* ─────────────────────────────────────────────────
   CTA RIGHT PANEL illustrated SVG
───────────────────────────────────────────────── */
function CtaIllustration() {
  return (
    <div className="pr-cta-illustration" aria-hidden="true">
      <svg viewBox="0 0 400 320" fill="none" xmlns="http://www.w3.org/2000/svg" className="pr-cta-svg">
        {/* background grid */}
        {[0,1,2,3,4,5,6,7].map(i => (
          <line key={`hg${i}`} x1="0" y1={i*46} x2="400" y2={i*46} stroke="rgba(255,255,255,0.03)" strokeWidth="1"/>
        ))}
        {[0,1,2,3,4,5,6,7,8,9].map(i => (
          <line key={`vg${i}`} x1={i*46} y1="0" x2={i*46} y2="320" stroke="rgba(255,255,255,0.03)" strokeWidth="1"/>
        ))}

        {/* large decorative bracket left */}
        <path d="M60 60 L40 60 L40 260 L60 260" stroke="rgba(255,255,255,0.12)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        {/* large decorative bracket right */}
        <path d="M340 60 L360 60 L360 260 L340 260" stroke="rgba(255,255,255,0.12)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>

        {/* center icon cluster */}
        {/* outer glow ring */}
        <circle cx="200" cy="160" r="80" stroke="rgba(255,255,255,0.04)" strokeWidth="24"/>
        {/* ring */}
        <circle cx="200" cy="160" r="68" stroke="rgba(255,255,255,0.08)" strokeWidth="1.5"/>
        <circle cx="200" cy="160" r="50" stroke="rgba(255,255,255,0.1)" strokeWidth="1"/>

        {/* lightbulb / idea icon */}
        <path d="M200 116 C185 116 174 127 174 141 C174 152 181 161 190 166 L190 175 L210 175 L210 166 C219 161 226 152 226 141 C226 127 215 116 200 116Z" stroke="rgba(255,255,255,0.5)" strokeWidth="1.8" strokeLinejoin="round"/>
        <line x1="190" y1="175" x2="210" y2="175" stroke="rgba(255,255,255,0.35)" strokeWidth="1.6" strokeLinecap="round"/>
        <line x1="192" y1="180" x2="208" y2="180" stroke="rgba(255,255,255,0.25)" strokeWidth="1.6" strokeLinecap="round"/>
        <line x1="196" y1="185" x2="204" y2="185" stroke="rgba(255,255,255,0.15)" strokeWidth="1.6" strokeLinecap="round"/>
        {/* filament */}
        <path d="M193 148 Q200 143 207 148" stroke="rgba(255,255,255,0.4)" strokeWidth="1.4" fill="none" strokeLinecap="round"/>

        {/* sparkle dots around bulb */}
        <circle cx="164" cy="125" r="2.5" fill="rgba(255,255,255,0.3)"/>
        <circle cx="238" cy="118" r="2" fill="rgba(255,255,255,0.22)"/>
        <circle cx="165" cy="160" r="1.5" fill="rgba(255,255,255,0.18)"/>
        <circle cx="236" cy="158" r="3" fill="rgba(255,255,255,0.18)"/>
        <circle cx="200" cy="100" r="2" fill="rgba(255,255,255,0.25)"/>

        {/* small floating chips */}
        <rect x="80" y="90" width="64" height="22" rx="11" stroke="rgba(255,255,255,0.12)" strokeWidth="1" fill="rgba(255,255,255,0.03)"/>
        <text x="112" y="105" textAnchor="middle" fill="rgba(255,255,255,0.3)" fontSize="8" fontFamily="monospace" letterSpacing="1">IDEA</text>

        <rect x="256" y="210" width="72" height="22" rx="11" stroke="rgba(255,255,255,0.12)" strokeWidth="1" fill="rgba(255,255,255,0.03)"/>
        <text x="292" y="225" textAnchor="middle" fill="rgba(255,255,255,0.3)" fontSize="8" fontFamily="monospace" letterSpacing="1">DELIVERD</text>

        <rect x="76" y="210" width="80" height="22" rx="11" stroke="rgba(255,255,255,0.12)" strokeWidth="1" fill="rgba(255,255,255,0.03)"/>
        <text x="116" y="225" textAnchor="middle" fill="rgba(255,255,255,0.3)" fontSize="8" fontFamily="monospace" letterSpacing="1">IN-HOUSE</text>

        <rect x="258" y="88" width="72" height="22" rx="11" stroke="rgba(255,255,255,0.12)" strokeWidth="1" fill="rgba(255,255,255,0.03)"/>
        <text x="294" y="103" textAnchor="middle" fill="rgba(255,255,255,0.3)" fontSize="8" fontFamily="monospace" letterSpacing="1">BUILD</text>

        {/* connector lines from chips to center */}
        <line x1="144" y1="101" x2="172" y2="132" stroke="rgba(255,255,255,0.06)" strokeWidth="1" strokeDasharray="3 5"/>
        <line x1="256" y1="221" x2="218" y2="190" stroke="rgba(255,255,255,0.06)" strokeWidth="1" strokeDasharray="3 5"/>
        <line x1="156" y1="221" x2="183" y2="188" stroke="rgba(255,255,255,0.06)" strokeWidth="1" strokeDasharray="3 5"/>
        <line x1="258" y1="99" x2="228" y2="130" stroke="rgba(255,255,255,0.06)" strokeWidth="1" strokeDasharray="3 5"/>
      </svg>
    </div>
  );
}

/* ═══════════════════════════════════════════════════
   PAGE COMPONENT
═══════════════════════════════════════════════════ */
export default function Products() {
  const [activeFilter, setActiveFilter] = useState("all");
  const vis = useReveal();
  const navigate = useNavigate();

  const filtered = activeFilter === "all"
    ? PRODUCTS
    : PRODUCTS.filter(p => p.status === activeFilter);

  const liveCount     = PRODUCTS.filter(p => p.status === "live").length;
  const progressCount = PRODUCTS.filter(p => p.status === "progress" || p.status === "prototype").length;
  const ideaCount     = PRODUCTS.filter(p => p.status === "idea").length;

  return (
    <div className="pr-root">

      {/* ══ HERO ══ */}
      <section className="pr-hero">
        <div className="pr-hero-inner">
          <div className="pr-hero-l">
            <p className="pr-eyebrow">
              <span className="pr-eyebrow-line" />
              D-Tech Studios Portfolio
            </p>
            <h1 className="pr-h1">
              10 products.<br />
              <span className="pr-h1-muted">One studio.</span>
            </h1>
            <p className="pr-hero-body">
              From privacy infrastructure to voice AI, crypto tools to typography utilities
              every product on this page was conceived, designed, and built entirely in-house
              at D-Tech Studios. No outsourcing. Full ownership.
            </p>
          </div>

          {/* stat strip */}
          <div className="pr-hero-stats">
            <div className="pr-hstat">
              <strong>{liveCount}</strong>
              <span>Live</span>
            </div>
            <div className="pr-hstat-div" />
            <div className="pr-hstat">
              <strong>{progressCount}</strong>
              <span>Building</span>
            </div>
            <div className="pr-hstat-div" />
            <div className="pr-hstat">
              <strong>{ideaCount}</strong>
              <span>Roadmap</span>
            </div>
            <div className="pr-hstat-div" />
            <div className="pr-hstat">
              <strong>{PRODUCTS.length}</strong>
              <span>Total</span>
            </div>
          </div>
        </div>

        {/* scrolling domain ticker */}
        <div className="pr-domain-ticker">
          <div className="pr-dt-track">
            {[...PRODUCTS, ...PRODUCTS].map((p, i) => (
              <span className="pr-dt-item" key={i}>
                <span className="pr-dt-dot" style={{ background: p.accent }} />
                {p.domain}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* ══ INNOVATION MANIFESTO BANNER ══ */}
      <section
        className={`pr-section pr-manifesto ${vis("manifesto") ? "pr-in" : ""}`}
        data-key="manifesto"
      >
        {/* LEFT */}
        <div className="pr-manifesto-inner">
          <div className="pr-manifesto-badge">
            <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="10" height="10">
              <circle cx="8" cy="8" r="4" fill="currentColor"/>
            </svg>
            We're building the future
          </div>
          <h2 className="pr-manifesto-h">
            The world doesn't need more apps.<br/>
            <em>It needs better ones.</em>
          </h2>
          <p className="pr-manifesto-sub">
            We're not here to clone what's already working. We're here to find the gaps the tools people reach for that don't exist yet, the workflows still done manually, the problems every person has but nobody's solved cleanly. That's where D-Tech Studios lives.
          </p>
          <div className="pr-manifesto-line" />
          <p className="pr-manifesto-quote">
            "Automation isn't about replacing humans. It's about giving humans back their time so they can do the work that actually matters."
          </p>
        </div>

        {/* RIGHT new panel */}
        <ManifestoRight />

        {/* floating ticker words */}
        <div className="pr-manifesto-words" aria-hidden="true">
          {["AUTOMATE", "INNOVATE", "BUILD", "SCALE", "DISRUPT", "SOLVE", "CREATE", "RELEASED"].map((w, i) => (
            <span className="pr-mw" key={i} style={{ animationDelay: `${i * 0.5}s` }}>{w}</span>
          ))}
        </div>
      </section>

      {/* ══ FILTER BAR ══ */}
      <div className="pr-filter-bar" data-key="filters">
        <div className="pr-filter-inner">
          <span className="pr-filter-label">Filter by status</span>
          <div className="pr-filter-btns">
            {FILTERS.map(f => (
              <button
                key={f.key}
                className={`pr-filter-btn ${activeFilter === f.key ? "pr-filter-btn--active" : ""}`}
                onClick={() => setActiveFilter(f.key)}
              >
                {f.label}
                <span className="pr-filter-count">{f.count}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* ══ PRODUCT GRID ══ */}
      <section className="pr-grid-section">
        <div className="pr-results-bar">
          <span className="pr-results-txt">
            Showing <strong>{filtered.length}</strong> product{filtered.length !== 1 ? "s" : ""}
            {activeFilter !== "all" ? ` · ${FILTERS.find(f => f.key === activeFilter)?.label}` : ""}
          </span>
        </div>

        <div className="pr-grid">
          {filtered.map((product, i) => (
            <ProductCard key={product.id} product={product} index={i} />
          ))}
        </div>
      </section>

      {/* ══ INNOVATION PILLARS ══ */}
      <section
        className={`pr-section pr-innov ${vis("innov") ? "pr-in" : ""}`}
        data-key="innov"
      >
        {/* head now split with center divider */}
        <div className="pr-innov-head pr-innov-head--split">
          <div className="pr-innov-head-l">
            <p className="pr-tag">Why we exist</p>
            <h2 className="pr-h2">Building for the next era<br /><em>of how work gets done.</em></h2>
          </div>
          {/* center vertical divider */}
          <div className="pr-innov-head-div" aria-hidden="true" />
          <div className="pr-innov-head-r">
            <p className="pr-innov-sub">
              Every product we release is a small piece of a larger mission: closing the gap between a problem and its solution. We believe software should be invisible, instant, and intelligent.
            </p>
            <div className="pr-innov-head-stat">
              <span className="pr-innov-head-n">6</span>
              <span className="pr-innov-head-slabel">core principles we build by</span>
            </div>
          </div>
        </div>

        <div className="pr-innov-grid">
          {[
            {
              icon: <IconBolt />,
              title: "Speed over ceremony",
              body: "We cut through the noise. No lengthy planning cycles, no death-by-committee. We identify real problems and deliver working solutions fast.",
            },
            {
              icon: <IconGlobe />,
              title: "Tools for everyone",
              body: "Not just for enterprises. Not just for developers. We build tools that a student, a freelancer, a founder, or a Fortune 500 team can all use without a manual.",
            },
            {
              icon: <IconCode />,
              title: "Full-stack ownership",
              body: "We own every pixel, every database row, every deployment pipeline. That means faster iterations, zero vendor lock-in, and radical accountability.",
            },
            {
              icon: <IconRocket />,
              title: "Automation-first thinking",
              body: "Every repetitive task is a problem waiting to be automated. We design products with automation at the core not bolted on as an afterthought.",
            },
            {
              icon: <IconEye />,
              title: "Radical simplicity",
              body: "The hardest thing to build is something simple. We relentlessly trim complexity until the product does exactly what it needs to and nothing more.",
            },
            {
              icon: <IconTarget />,
              title: "Long-term thinking",
              body: "Launching is just step one. We maintain, evolve, and improve every product. Our roadmap stretches years ahead, not just to the next release.",
            },
          ].map((pillar, i) => (
            <div className="pr-innov-card" key={i} style={{ animationDelay: `${i * 0.07}s` }}>
              <div className="pr-innov-icon">{pillar.icon}</div>
              <h4 className="pr-innov-title">{pillar.title}</h4>
              <p className="pr-innov-body">{pillar.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ══ IMPACT NUMBERS ══ */}
      <section
        className={`pr-section pr-impact ${vis("impact") ? "pr-in" : ""}`}
        data-key="impact"
      >
        <div className="pr-impact-inner">
          <div className="pr-impact-l">
            <p className="pr-tag">The numbers</p>
            <h2 className="pr-h2">Built, not<br /><em>just planned.</em></h2>
<p className="pr-impact-body">
  Ideas are cheap. Execution is everything. Here's what D-Tech Studios has built, maintained, and continues to grow all in-house, fully owned by us.
</p>
          </div>

          {/* center vertical divider */}
          <div className="pr-impact-divider" aria-hidden="true">
            <div className="pr-impact-div-line" />
            <div className="pr-impact-div-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.6"/>
                <path d="M12 2v3M12 19v3M2 12h3M19 12h3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
              </svg>
            </div>
            <div className="pr-impact-div-line" />
          </div>

          <div className="pr-impact-r">
            {[
              { n: "10", label: "Products Built",     sub: "From idea to production" },
              { n: "7",  label: "Live & Running",      sub: "Accessible right now" },
              { n: "6",  label: "Verticals Covered",   sub: "Finance, AI, Privacy, Design & more" },
              { n: "1",  label: "Studio Behind It All", sub: "100% in-house, 0% outsourced" },
            ].map((stat, i) => (
              <div className="pr-impact-stat" key={i}>
                <strong className="pr-impact-n">{stat.n}</strong>
                <div className="pr-impact-info">
                  <span className="pr-impact-label">{stat.label}</span>
                  <span className="pr-impact-sub">{stat.sub}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ CATEGORIES SECTION ══ */}
      <section
        className={`pr-section pr-cats ${vis("cats") ? "pr-in" : ""}`}
        data-key="cats"
      >
        <div className="pr-cats-head">
          <p className="pr-tag">What we build</p>
          <h2 className="pr-h2">Spanning six verticals.</h2>
        </div>
        <div className="pr-cats-grid">
          {[
            { icon: <CatIconEmail />,   label: "Privacy & Email",      n: 1 },
            { icon: <CatIconVoice />,   label: "Voice & Audio AI",     n: 1 },
            { icon: <CatIconFinance />, label: "Finance & Tax",        n: 2 },
            { icon: <CatIconCrypto />,  label: "Crypto & Web3",        n: 1 },
            { icon: <CatIconDesign />,  label: "Design & Productivity",n: 2 },
            { icon: <CatIconAI />,      label: "AI & Developer Tools", n: 3 },
          ].map((c, i) => (
            <div className="pr-cat-card" key={i} style={{ animationDelay: `${i * 0.06}s` }}>
              <span className="pr-cat-icon">{c.icon}</span>
              <span className="pr-cat-label">{c.label}</span>
              <span className="pr-cat-n">{c.n} product{c.n > 1 ? "s" : ""}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ══ BUILD PHILOSOPHY ══ */}
      <section
        className={`pr-section pr-phil ${vis("phil") ? "pr-in" : ""}`}
        data-key="phil"
      >
        <div className="pr-phil-inner">
          <div className="pr-phil-l">
            <p className="pr-tag">The D-Tech Way</p>
            <h2 className="pr-h2">
              Every product<br />
              <em>earns its place.</em>
            </h2>
            <p className="pr-phil-body">
  We don't release products for the sake of release. Each one solves a real problem, is built with care, and is fully owned by us end to end.
</p>
          </div>
          <div className="pr-phil-r">
            {[
              { n: "01", title: "Idea → Validated",    body: "Before a line of code is written, we confirm the problem is real and the solution is better than what exists." },
              { n: "02", title: "Prototype → Tested",  body: "We build rough, test hard, and kill features that don't pull their weight. Prototypes are meant to break." },
              { n: "03", title: "Launch → Maintained", body: "Going live is the beginning, not the end. We maintain, update, and grow every product we release." },
            ].map((s, i) => (
              <div className="pr-phil-step" key={i}>
                <span className="pr-phil-n">{s.n}</span>
                <div>
                  <h4>{s.title}</h4>
                  <p>{s.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ VISION STRIP ══ */}
      <section
        className={`pr-section pr-vision ${vis("vision") ? "pr-in" : ""}`}
        data-key="vision"
      >
        <div className="pr-vision-inner">
          <div className="pr-vision-text">
            <p className="pr-tag">Where we're going</p>
            <h2 className="pr-h2">The roadmap<br/><em>is just getting started.</em></h2>
            <p className="pr-vision-body">
              The products you see today are version 1 of a much larger ecosystem. We're building
              interconnected tools that talk to each other, share infrastructure, and compound in
              value over time. The goal isn't 10 products. It's a platform.
            </p>
          </div>
          <div className="pr-vision-list">
            {[
              { phase: "Now",    items: ["10 standalone products live or in development", "Core tool infrastructure established", "First users across all categories"] },
              { phase: "Next",   items: ["Cross-product integrations & shared APIs", "Mobile-first versions of top tools", "Developer platform & public API access"] },
              { phase: "Future", items: ["AI-powered automation layer across all products", "Unified D-Tech account & dashboard", "Enterprise tiers for power users & teams"] },
            ].map((row, i) => (
              <div className="pr-vision-row" key={i}>
                <span className="pr-vision-phase">{row.phase}</span>
                <div className="pr-vision-items">
                  {row.items.map((item, j) => (
                    <span className="pr-vision-item" key={j}>
                      <svg viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" width="8" height="8" style={{flexShrink:0}}>
                        <circle cx="4" cy="4" r="3" fill="currentColor" opacity="0.4"/>
                      </svg>
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ CTA ══ */}
      <section
        className={`pr-section pr-cta ${vis("cta") ? "pr-in" : ""}`}
        data-key="cta"
      >
        {/* LEFT existing content */}
        <div className="pr-cta-inner">
          <p className="pr-tag">Got a product idea?</p>
          <h2 className="pr-h2">We build what we believe in.</h2>
          <p className="pr-cta-body">
            All products are built in-house. If you have a collaboration or partnership
            inquiry, reach out we're always interested in ideas that solve real problems.
          </p>
          <div className="pr-cta-btns">
            <button className="pr-btn-dark"
            onClick={() => navigate("/Contact")}
            >
              Get in Touch <span className="pr-btn-arr">→</span>
            </button>
            <button className="pr-btn-bare"
            onClick={() => navigate("/About")}
            >
              View the Studio</button>
          </div>
        </div>

        {/* RIGHT SVG illustration */}
        <CtaIllustration />
      </section>

    </div>
  );
}